import setupAppConfig from '../utils/setupAppConfig';

const app = {};

setupAppConfig(app);

export default app;
